/*
 * MRS. MAILBOX — Carousel Controls JS
 * assets/mm-carousel-controls.js
 *
 * - Ok butonlarıyla scroll
 * - Dot'larla snap scroll
 * - Mobilde touch scroll native çalışır (JS gerekmez)
 */

(function () {
  'use strict';

  function updateControls(trackEl, targetId) {
    var scrollLeft  = trackEl.scrollLeft;
    var maxScroll   = trackEl.scrollWidth - trackEl.clientWidth;
    var firstItem   = trackEl.querySelector('[data-carousel-item]') || trackEl.firstElementChild;
    var gap         = parseFloat(getComputedStyle(trackEl).gap) || 0;
    var itemWidth   = firstItem ? firstItem.offsetWidth + gap : 1;
    var dots        = document.querySelectorAll('[data-carousel-dots="' + targetId + '"] .mm-carousel-dot');
    var totalDots   = dots.length;

    // Sona gelindiyse son dot aktif, başa gelindiyse ilk dot aktif,
    // ortada ise scrollLeft / itemWidth ile hesapla
    var activeIndex;
    if (scrollLeft <= 2) {
      activeIndex = 0;
    } else if (scrollLeft >= maxScroll - 2) {
      activeIndex = totalDots - 1;
    } else {
      activeIndex = Math.round(scrollLeft / itemWidth);
      // Sınırla
      activeIndex = Math.max(0, Math.min(activeIndex, totalDots - 1));
    }

    dots.forEach(function (dot, i) {
      var isActive = i === activeIndex;
      dot.classList.toggle('mm-carousel-dot--active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    var leftArrows  = document.querySelectorAll('[data-carousel-target="' + targetId + '"][data-dir="left"]');
    var rightArrows = document.querySelectorAll('[data-carousel-target="' + targetId + '"][data-dir="right"]');
    leftArrows.forEach(function (btn) {
      btn.disabled = scrollLeft <= 2;
      btn.classList.toggle('mm-carousel-arrow--disabled', scrollLeft <= 2);
    });
    rightArrows.forEach(function (btn) {
      btn.disabled = scrollLeft >= maxScroll - 2;
      btn.classList.toggle('mm-carousel-arrow--disabled', scrollLeft >= maxScroll - 2);
    });
  }

  // ── Ok click
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-carousel-target][data-dir]');
    if (!btn) return;
    var targetId = btn.dataset.carouselTarget;
    var dir      = btn.dataset.dir;
    var trackEl  = document.getElementById(targetId);
    if (!trackEl) return;
    var firstItem = trackEl.querySelector('[data-carousel-item]') || trackEl.firstElementChild;
    var gap       = parseFloat(getComputedStyle(trackEl).gap) || 0;
    var itemWidth = firstItem ? firstItem.offsetWidth + gap : 200;
    trackEl.scrollBy({ left: dir === 'left' ? -itemWidth : itemWidth, behavior: 'smooth' });
    setTimeout(function () { updateControls(trackEl, targetId); }, 350);
  });

  // ── Dot click
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-carousel-dots] [data-index]');
    if (!dot) return;
    var targetId = dot.dataset.carouselTarget;
    var index    = parseInt(dot.dataset.index, 10);
    var trackEl  = document.getElementById(targetId);
    if (!trackEl) return;
    var firstItem = trackEl.querySelector('[data-carousel-item]') || trackEl.firstElementChild;
    var gap       = parseFloat(getComputedStyle(trackEl).gap) || 0;
    var itemWidth = firstItem ? firstItem.offsetWidth + gap : 0;
    trackEl.scrollTo({ left: index * itemWidth, behavior: 'smooth' });
    setTimeout(function () { updateControls(trackEl, targetId); }, 350);
  });

  // ── Scroll → dots/arrows güncelle
  var scrollTimers = {};
  document.addEventListener('scroll', function (e) {
    var trackEl  = e.target;
    if (!trackEl || !trackEl.id) return;
    var targetId = trackEl.id;
    if (!document.querySelector('[data-carousel-target="' + targetId + '"]')) return;
    clearTimeout(scrollTimers[targetId]);
    scrollTimers[targetId] = setTimeout(function () {
      updateControls(trackEl, targetId);
    }, 80);
  }, true);

  // ── Init
  document.addEventListener('DOMContentLoaded', function () {
    var allTargets = document.querySelectorAll('[data-carousel-target]');
    var seen = {};
    allTargets.forEach(function (el) {
      var id = el.dataset.carouselTarget;
      if (seen[id]) return;
      seen[id] = true;
      var trackEl = document.getElementById(id);
      if (trackEl) updateControls(trackEl, id);
    });
  });
})();